import { render, staticRenderFns } from "./MaquinaSensorTiempoReal.vue?vue&type=template&id=01fed326&"
import script from "./MaquinaSensorTiempoReal.vue?vue&type=script&lang=js&"
export * from "./MaquinaSensorTiempoReal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports